<nav
    id="mobile-bottom-navigation"
    *ngIf="isLoggedIn"
    av-data="sidebar-mobile"
    class="hidden md:hidden"
    aria-label="Main navigation">
    <button
        type="button"
        class="mobile-bottom-nav-item"
        [class.mobile-bottom-nav-item-active]="locationPath === ''"
        (click)="myTracks()">
        <img src="assets/img/navbar/library.svg" alt="" aria-hidden="true" />
        <span>My Songs</span>
    </button>

    <button
        type="button"
        class="mobile-bottom-nav-item mobile-bottom-nav-create"
        [class.mobile-bottom-nav-item-active]="locationPath === '/create'"
        (click)="createNewTrack()"
        av-data="sidebar-create-btn">
        <span class="mobile-bottom-nav-create-pill">
            <img
                src="assets/img/navbar/generative_sparkles.svg"
                alt=""
                aria-hidden="true" />
            <span>Create</span>
        </span>
    </button>

    <button
        type="button"
        class="mobile-bottom-nav-item"
        [class.mobile-bottom-nav-item-active]="
            mobileSettingsMenuOpen || locationPath === '/billing'
        "
        [attr.aria-expanded]="mobileSettingsMenuOpen"
        (click)="toggleMobileSettingsMenu()">
        <img
            src="assets/img/pianoroll/settings.svg"
            alt=""
            aria-hidden="true" />
        <span>Settings</span>
    </button>
</nav>

<menu-options
    *ngIf="isLoggedIn && mobileSettingsMenuOpen && mobileSettingsMenuOptions"
    [menuOptions]="mobileSettingsMenuOptions"
    (close)="closeMobileSettingsMenu()"></menu-options>

<div id="sidebar" *ngIf="isLoggedIn && !isCollapsed" av-data="sidebar-desktop">
    <button
        type="button"
        class="toggle-collapse-button"
        aria-label="Collapse navbar"
        (click)="toggleNavbar()">
        <img src="assets/img/navbar/collapse-navbar.svg" alt="" />
    </button>

    <a href="/" id="logo" class="flex">
        <img src="assets/img/navbar/aiva.svg" />
        AIVA
    </a>

    <a-button
        class="navbar-create-button"
        width="100%"
        type="secondary"
        icon="assets/img/navbar/generative_sparkles.svg"
        (onClick)="createNewTrack()"
        label="Create"
        avData="sidebar-create-btn"></a-button>

    <div class="navbar-buttons-container">
        <div
            id="sidebar-title"
            (click)="myTracks()"
            [ngClass]="{ 'highlighted-menu': locationPath === '' }">
            <img
                id="sidebar-title-icon"
                class="matched-navbar-icon home-navbar-icon"
                src="assets/img/navbar/library.svg" />My Songs
            <div
                id="new-composition-badge"
                class="tooltip"
                *ngIf="unplayedComposition">
                <span class="tooltiptext">New songs are available</span>
            </div>
        </div>

        <div
            id="sidebar-title"
            [ngClass]="{ 'highlighted-menu': locationPath === '/billing' }"
            (click)="billing()">
            <img
                id="sidebar-title-icon"
                class="billing-navbar-icon"
                src="assets/img/navbar/billing.svg" />Billing
        </div>

        <div id="sidebar-title" (click)="settings()">
            <img
                id="sidebar-title-icon"
                src="assets/img/pianoroll/settings.svg" />Settings
        </div>

        <div id="sidebar-title" (click)="openSupportChat()">
            <img
                id="sidebar-title-icon"
                class="matched-navbar-icon"
                src="assets/img/menu/support.svg" />Support chat
        </div>

        <button
            type="button"
            id="sidebar-title"
            class="old-aiva-link"
            (click)="openLegacyAiva()">
            <img
                id="sidebar-title-icon"
                src="assets/img/navbar/switch.svg"
                alt="" />Use AIVA 1.0
        </button>
    </div>

    <div id="user-menu-container" (clickOutside)="closeUserMenu()">
        <div
            id="sidebar-title"
            class="download-quota-container"
            *ngIf="!userMenuOpen && getDailyGenerationsLeft() !== null">
            <div
                class="download-quota-usage"
                [tooltip]="getGenerationQuotaTooltip()"
                [tooltip-disabled]="getGenerationQuotaTooltipDisabled()"
                [tooltip-position]="'middle-top'"
                [tooltip-marginBottom]="6"
                [tooltip-match-origin-width]="true"
                [tooltip-class]="'quota-tooltip'"
                [tooltip-textAlign]="'left'">
                <div class="download-quota-progress-bar-container">
                    <div
                        class="download-quota-progress-bar"
                        [style.width.%]="getGenerationQuotaPercentage()"></div>
                </div>

                <div class="download-quota-subtitle">
                    {{ getDailyGenerationsLeft() }} daily generations left
                </div>
            </div>
        </div>

        <div
            id="user-menu-button"
            #userMenuButton
            [ngClass]="{ 'user-menu-main-button': userMenuOpen }"
            class="flex justify-around items-center"
            (mousedown)="$event.stopPropagation()"
            (click)="toggleUserMenu($event)">
            <img src="assets/img/navbar/user-picture.png" id="user-picture" />
            <div id="menu-email" class="overflow-text">{{ email }}</div>
            <img
                src="assets/img/navbar/up-chevron.png"
                id="down-chevron"
                *ngIf="!userMenuOpen" />
            <img
                src="assets/img/navbar/down-chevron.png"
                id="down-chevron"
                *ngIf="userMenuOpen" />
        </div>

        <menu-options
            *ngIf="userMenuOpen && userMenuOptions"
            [width]="userMenuWidth"
            [menuOptions]="userMenuOptions"
            (close)="closeUserMenu()"></menu-options>
    </div>
</div>

<div
    id="sidebar-collapsed"
    class="hidden md:block"
    *ngIf="isCollapsed && isDesktop"
    [ngClass]="{ 'sidebar-mac-electron': isMacElectronApp }"
    av-data="sidebar-desktop">
    <div class="sidebar-collapsed-content">
        <div class="logo" (click)="myTracks()">
            <img src="assets/img/navbar/aiva.svg" />
        </div>

        <button
            type="button"
            class="toggle-collapse-button"
            aria-label="Expand navbar"
            (click)="toggleNavbar()">
            <img src="assets/img/navbar/collapse-navbar.svg" alt="" />
        </button>

        <div
            class="create-button-circle tooltip flex justify-center items-center"
            (click)="createNewTrack($event)">
            <img src="assets/img/navbar/generative_sparkles.svg" />
            <span class="tooltiptext">Create Track</span>
        </div>

        <div
            class="menu-items navbar-buttons-container"
            [perfectScrollbar]="scrollConfig">
            <div
                class="menu-item"
                [ngClass]="{ 'highlighted-menu': locationPath === '' }"
                (click)="myTracks()"
                [tooltip]="'My Songs'"
                [tooltip-marginTop]="-18"
                [tooltip-ignore]="'#new-composition-badge'">
                <img
                    class="collapsed-sidebar-icon matched-navbar-icon home-navbar-icon my-tracks"
                    src="assets/img/navbar/library.svg" />
                <div id="new-composition-badge" class="badge tooltip">
                    <span class="tooltiptext">New songs are available</span>
                </div>
            </div>

            <div
                class="menu-item"
                [ngClass]="{ 'highlighted-menu': locationPath === '/billing' }"
                (click)="billing()"
                [tooltip]="'Billing'"
                [tooltip-marginTop]="-20">
                <img
                    class="collapsed-sidebar-icon billing billing-navbar-icon"
                    src="assets/img/navbar/billing.svg" />
            </div>

            <div
                class="menu-item"
                (click)="settings()"
                [tooltip]="'Settings'"
                [tooltip-marginTop]="-19">
                <img
                    class="collapsed-sidebar-icon"
                    src="assets/img/pianoroll/settings.svg" />
            </div>

            <div
                class="menu-item"
                (click)="openSupportChat()"
                [tooltip]="'Support chat'"
                [tooltip-marginTop]="-19">
                <img
                    class="collapsed-sidebar-icon matched-navbar-icon"
                    src="assets/img/menu/support.svg" />
            </div>

            <button
                type="button"
                class="menu-item old-aiva-link"
                (click)="openLegacyAiva()"
                aria-label="Use AIVA 1.0"
                [tooltip]="'Use AIVA 1.0'"
                [tooltip-marginTop]="-19">
                <img
                    class="collapsed-sidebar-icon"
                    src="assets/img/navbar/switch.svg"
                    alt="" />
            </button>
        </div>

        <div id="user-menu-container">
            <!--<progress-circle
                *ngIf="!legacyBilling()"
                class="navbar"
                [progress]="getDownloads()"
                [total]="getDownloadsQuota()"
                width="70"
                [tooltip]="
                    'You have used ' +
                    getDownloads() +
                    ' out of ' +
                    getDownloadsQuota() +
                    ' monthly available downloads.'
                "></progress-circle>-->

            <div class="user-menu">
                <div class="user-menu-button" (click)="openUserMenu($event)">
                    <img
                        class=""
                        src="assets/img/navbar/user-picture.png"
                        id="user-picture" />
                </div>
            </div>
        </div>
    </div>
</div>
